import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/slices/authSlice';
import useIsMobile from '../../hooks/useIsMobile';

const TICKER_ITEMS = ['FREE SHIPPING ABOVE ₹999','NEW ARRIVALS EVERY WEEK','AUTHENTICALLY BENGALI','EXCLUSIVE DESIGNS','CHA · ADDA · IDENTITY'];
const NAV_LINKS    = [['/', 'Home'], ['/products', 'Shop'], ['/products?category=kurta', 'Kurta'], ['/products?category=tshirt', 'T-Shirts'], ['/about', 'About']];

export default function Navbar() {
  const dispatch    = useDispatch();
  const navigate    = useNavigate();
  const { user }    = useSelector((s) => s.auth);
  const { items }   = useSelector((s) => s.cart);
  const isMobile    = useIsMobile();
  const [open, setOpen] = useState(false);

  const handleLogout = () => { dispatch(logout()); navigate('/'); setOpen(false); };
  const close        = () => setOpen(false);

  const tickerContent = [...TICKER_ITEMS, ...TICKER_ITEMS].map((t, i) => (
    <span key={i}>{t}<span className="tdot"> ✦ </span></span>
  ));

  return (
    <>
      {/* Ticker */}
      <div className="ticker-wrap">
        <div className="ticker-track">{tickerContent}</div>
      </div>

      {/* Nav */}
      <nav style={S.nav}>
        {/* Hamburger (mobile only) */}
        {isMobile && (
          <button style={S.burger} onClick={() => setOpen(o => !o)} aria-label="Menu">
            <span style={S.burgerLine} />
            <span style={S.burgerLine} />
            <span style={S.burgerLine} />
          </button>
        )}

        <Link to="/" style={S.logoWrap} onClick={close}>
          <img src="/logo-transparent.png" alt="Bhadralok" style={S.logoImg} />
        </Link>

        {/* Desktop nav links */}
        {!isMobile && (
          <ul style={S.links}>
            {NAV_LINKS.map(([to, label]) => (
              <li key={to}><Link to={to} style={S.link}>{label}</Link></li>
            ))}
          </ul>
        )}

        {/* Actions */}
        <div style={S.actions}>
          {!isMobile && user && (
            <>
              {user.role === 'admin' && <Link to="/admin"     style={S.acctBtn}>Admin</Link>}
              <Link to="/dashboard" style={S.acctBtn}>{user.name.split(' ')[0]}</Link>
              <button onClick={handleLogout} style={S.acctBtn}>Logout</button>
            </>
          )}
          {!isMobile && !user && (
            <button onClick={() => navigate('/login')} style={S.acctBtn}>Account</button>
          )}
          <Link to="/cart" style={S.cartBtn} onClick={close}>
            🛒 {!isMobile && 'Cart'}
            {items.length > 0 && <span style={S.cartBadge}>{items.length}</span>}
          </Link>
        </div>
      </nav>

      {/* Mobile Drawer */}
      {isMobile && open && (
        <div className="mob-drawer">
          <div className="mob-drawer-bg" onClick={close} />
          <div className="mob-drawer-panel">
            {NAV_LINKS.map(([to, label]) => (
              <Link key={to} to={to} className="mob-nav-link" onClick={close}>{label}</Link>
            ))}
            <div style={{ borderTop:'1px solid rgba(255,255,255,.12)', margin:'12px 0' }} />
            {user ? (
              <>
                <Link to="/dashboard" className="mob-nav-link" onClick={close}>My Account</Link>
                {user.role === 'admin' && <Link to="/admin" className="mob-nav-link" onClick={close}>Admin Panel</Link>}
                <button onClick={handleLogout} style={S.mobSignOut}>Sign Out</button>
              </>
            ) : (
              <>
                <Link to="/login"    className="mob-nav-link" onClick={close}>Login</Link>
                <Link to="/register" className="mob-nav-link" onClick={close}>Register</Link>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
}

const S = {
  nav: {
    position: 'fixed', top: 'var(--ticker-h)', left: 0, right: 0, zIndex: 400,
    background: 'var(--black)', display: 'flex', alignItems: 'center',
    justifyContent: 'space-between', padding: '0 20px',
    height: 'var(--nav-h)', borderBottom: '3px solid var(--red)',
  },
  logoWrap: { display: 'flex', alignItems: 'center', background: '#fff', padding: '4px 8px' },
  logoImg:  { height: '38px', width: 'auto', display: 'block' },
  links:    { display: 'flex', alignItems: 'center', gap: '28px', listStyle: 'none' },
  link:     { color: 'rgba(255,255,255,.7)', fontSize: '13px', fontWeight: 500, letterSpacing: '1px', textTransform: 'uppercase', transition: 'color .2s' },
  actions:  { display: 'flex', alignItems: 'center', gap: '8px' },
  acctBtn:  { background: 'none', border: '1px solid rgba(255,255,255,.22)', color: 'rgba(255,255,255,.65)', padding: '7px 14px', fontFamily: 'var(--font-body)', fontSize: '11px', fontWeight: 600, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', transition: 'all .2s' },
  cartBtn:  { background: 'var(--red)', color: '#fff', padding: '8px 16px', fontFamily: 'var(--font-body)', fontSize: '12px', fontWeight: 700, letterSpacing: '1.5px', textTransform: 'uppercase', display: 'flex', alignItems: 'center', gap: '6px', transition: 'background .2s', position: 'relative' },
  cartBadge:{ background: 'var(--gold)', color: 'var(--black)', width: '17px', height: '17px', borderRadius: '50%', fontSize: '10px', fontWeight: 700, display: 'flex', alignItems: 'center', justifyContent: 'center' },
  burger:   { background: 'none', border: 'none', cursor: 'pointer', padding: '6px', display: 'flex', flexDirection: 'column', gap: '5px' },
  burgerLine:{ display: 'block', width: '22px', height: '2px', background: '#fff', borderRadius: '2px' },
  mobSignOut:{ display: 'block', width: '100%', background: 'var(--red)', color: '#fff', border: 'none', padding: '14px 28px', fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase', cursor: 'pointer', textAlign: 'left', marginTop: '12px' },
};
